import React from 'react';
import { Typography } from '@klp/design';
import { IconName, Illustration } from '@klp/design/Illustrations';
import type { Theme } from '@material-ui/core';
import { Button, Hidden } from '@material-ui/core';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import { useLayoutContext } from '@klp/layout/Layout/LayoutContext';

const styles = (theme: Theme) => ({
    mobileMenuButton: {
        display: 'inline-block',
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },
        textTransform: 'uppercase',
        lineHeight: 0.5,
    },
});

export const HeaderMobileMenu = () => {
    const classes = useKlpStyles({}, styles);

    const { toggleMenu } = useLayoutContext();

    return (
        <Hidden smUp={true}>
            <Button
                onClick={() => toggleMenu(true)}
                className={classes.mobileMenuButton}
            >
                <Illustration icon={IconName.MENU} klpColor="main" />
                <Typography
                    translation="general.menu"
                    klpTypographyVariant="small"
                />
            </Button>
        </Hidden>
    );
};
